import { platformApiFetch } from '@/services/platformApi/client';

interface ProviderAnalytics {
  provider_id: string;
  views: number;
  contact_clicks: number;
  period_start: string;
  period_end: string;
}

interface ProviderAnalyticsParams {
  providerId: string;
  startDate?: string;
  endDate?: string;
}

export async function getProviderAnalytics(providerId: string, startDate?: string, endDate?: string): Promise<ProviderAnalytics> {
  const query = new URLSearchParams();
  if (startDate) {
    query.set('startDate', startDate);
  }
  if (endDate) {
    query.set('endDate', endDate);
  }

  const suffix = query.toString();
  return platformApiFetch<ProviderAnalytics>(`/v1/provider-analytics/${providerId}${suffix ? `?${suffix}` : ''}`);
}